import React from 'react';

function Header() {
    return (
        <div className="bg-white flex justify-center items-center h-10 shrink-0 text-gray-900 shadow-lg font-medium">
            <span><b>Emin Azəroglu</b></span>
        </div>
    );
}

export default Header;
